// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"638":"43ef6b1a","968":"4baa855c"}[chunkId] + ".chunk.css";
};